import React, { useState, useEffect } from "react";
import axios from "axios";
import RSelect from "react-select";
import { Link, useHistory } from "react-router-dom";

import "./index.scss";
import "primeicons/primeicons.css";
import "remixicon/fonts/remixicon.css";
import "bootstrap/dist/css/bootstrap.min.css";

import constantObject from "../../config";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import Loader from "../../components/Loader";
import { formatTimes } from "../../common/Functions";

import { PiGlobe } from "react-icons/pi";
import { RiSearchLine } from "react-icons/ri";

import qubeimg from "../../assets/images/qube.png";
import document from "../../assets/images/doc.png";
import logoIcon from "../../assets/images/white-logo.png";
import txnIcon from "../../assets/images/latestblock.png";
import blockIcon from "../../assets/images/txn.png";

import toast, { Toaster } from 'react-hot-toast';
import { IoMdCopy } from "react-icons/io";

import { Tooltip } from "@mui/material";
import Divider from "@mui/material/Divider";
import RSearchBar from "material-ui-search-bar";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Button,
} from "@material-ui/core";

import { LineChart, Line, XAxis, YAxis, CartesianGrid, Legend, ResponsiveContainer, Tooltip as RechartsTooltip } from "recharts";


const HomePage = () => {
  const [blockTableData, setBlockTableData] = useState([]);
  const [transactionTableData, setTransactionTableData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selectedOption, setSelectedOption] = useState(null);
  const [query, setQuery] = useState("");
  const [cardValue, setCardValue] = useState({});

  const history = useHistory();

  // Function to handle page change
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  // Function to fetch updated block data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${constantObject.BaseUrl}/api/block?limit=${rowsPerPage}&page=${
            page + 1
          }`
        );

        const { data } = response?.data;

        setBlockTableData(data);
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    };

    // Fetch data immediately on mount
    fetchData();

    // Set up interval for fetching updated data
    const intervalId = setInterval(fetchData, 5000);

    return () => {
      clearInterval(intervalId);
    };
  }, [page, rowsPerPage]);

  // Function to fetch updated transaction data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${
            constantObject.BaseUrl
          }/api/transaction?limit=${rowsPerPage}&page=${page + 1}`
        );

        const { data } = response?.data;

        setTransactionTableData(data);
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    };

    // Fetch data immediately on mount
    fetchData();

    // Set up interval for fetching updated data
    const intervalId = setInterval(fetchData, 5000);

    return () => {
      clearInterval(intervalId);
    };
  }, [page, rowsPerPage]);

  const options = [
    { value: "Txn", label: "Transaction" },
    { value: "block", label: "Block" },
    { value: "address", label: "Address" },
  ];

  const handleSelectChange = (selectedOption) => {
    setSelectedOption(selectedOption);

    // Redirect to the selected page based on the value
    if (selectedOption) {
      switch (selectedOption.value) {
        case "Txn":
          history.push("/new_transactions");
          break;
        case "block":
          history.push("/new_block_page");
          break;
        case "address":
          history.push("/new_transactions");
          break;
        default:
          break;
      }
    }
  };

  const handleSearch = async () => {
    try {
      const response = await axios.get(
        `${
          constantObject.BaseUrl
        }/api/search?id=${query}&limit=${rowsPerPage}&page=${page + 1}`
      );

      if (response?.status === 200) {
        if (response?.data?.type === "BLOCK") {
          history.push(`/block_details/${response?.data?.data?.blockNumber}`);
        } else if (response?.data?.type === "TXN_HASH") {
          history.push(`/transactions_detail/${response?.data?.data?.hash}`);
        } else if (response?.data?.type === "ACC_ADDRESS") {
          history.push(`/address/${response?.data?.data?.address}`);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  // press on enter button call this function
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  function formatNumber(num) {
    if (num >= 1e12) {
      return (num / 1e12).toFixed(2) + " Trillion";
    }
    if (num >= 1e9) {
      return (num / 1e9).toFixed(2) + " Billion";
    }
    if (num >= 1e6) {
      return (num / 1e6).toFixed(2) + " Million";
    }
    return num;
  }

  function formatNumberMaxCap(num) {
    if (num >= 1e12) {
      return Math.floor(num / 1e12) + " Trillion";
    }
    if (num >= 1e9) {
      return Math.floor(num / 1e9) + " Billion";
    }
    if (num >= 1e6) {
      return Math.floor(num / 1e6) + " Million";
    }
    return Math.floor(num);
  }

  const cardData = [
    {
      title: "Total Supply",
      value: `${formatNumber(cardValue?.totalSupply || 0)} HEWE`,
    },
    {
      title: "Circulating Supply",
      value: `${formatNumber(Math.floor(cardValue?.currentCirculation || 0))} HEWE`,
    },
    {
      title: "Burned Supply",
      value: `${formatNumber(cardValue?.burnSupply || 0)} HEWE`,
    },
    {
      title: "Maximum Supply",
      value: `${formatNumberMaxCap(cardValue?.maxCap || 0)} HEWE`,
    },
  ];

  //get card key
  const getBlockCardKey = async () => {
    try {
      const response = await axios.get(
        `${constantObject.BaseUrl}/api/stats/supported_queries`
      );

      getBlockCardValue(response?.data);
    } catch (error) {
      console.log("Error fetching card key data:", error);
    }
  };

  //get card value
  const getBlockCardValue = async (val) => {
    try {
      // Join the array into a comma-separated string
      const queryParams = val.join(',');

      const response = await axios.get(
        `${constantObject.BaseUrl}/api/stats/detail?query=${queryParams}`
      );

      // Assuming you're trying to access `supplies` from the response
      setCardValue(response.data);
    } catch (error) {
      console.log("Error fetching card value data:", error);
    }
  };

  useEffect(() => {
    getBlockCardKey();
  }, []);


  const data = [
    { name: "Jan", value: 400 },
    { name: "Feb", value: 300 },
    { name: "Mar", value: 500 },
    { name: "Apr", value: 200 },
    { name: "May", value: 600 },
    { name: "Jun", value: 700 },
  ];

  // This is for copy address. 
  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      toast.success("Copied to clipboard!", {
        style: {
          background: '#4CAF50',
          color: 'white',
          border: "none",
          boxShadow:"none"
        },
      });
    }).catch((err) => {
      toast.error("Failed to copy!", {
        style: {
          background: '#f44336',
          color: 'white',
          border: "none",
          boxShadow:"none"
        },
      });
    });
  };


  return (
    <>
      <Navbar />

      {/* loader */}
      {isLoading && <Loader />}

      <div className="searchbar-container">
        <div className="subheading">AMC Smart Chain Explorer</div>

        <div className="searchbar">
          <RSelect
            value={selectedOption}
            onChange={handleSelectChange}
            options={options}
            placeholder="All Filters"
            className="homepage-selectbox"
            styles={{
              control: (provided) => ({
                ...provided,
                width:"120px",
                border: "none",
                outline: "none",
                borderBottomRightRadius: "0px",
                borderTopRightRadius: "0px",
              }),
            }}
          />

          {/* <RSearchBar
            onChange={handleSearch}
            onCancelSearch={() => handleSearch("")}
            placeholder="Search by Txn Hash / Block  / Address"
            className="homepage-searchbar"
            style={{
              width: "50%",
              height: "38px",
              borderTopLeftRadius: "0px",
              borderBottomLeftRadius: "0px",
              border: "none",
              outline: "none",
            }}
          /> */}

          <div className="custom-search-cant">
            <input
              type="text"
              placeholder="Search by Txn Hash / Block / Address"
              value={query}
              onChange={(event) => setQuery(event.target.value)}
              onKeyDown={handleKeyDown}
              className="custom-search-input"
              style={{borderRadius:"0px"}}
            />
            <button
              type="submit"
              className="custom-search-button"
              onClick={handleSearch}
              style={{borderTopLeftRadius:"0px", borderBottomLeftRadius:"0px"}}
            >
              <RiSearchLine />
            </button>
          </div>
        </div>

        {/* <div className="homepage-card-container">
          {cardData.map((card, index) => (
            <div className="homepage-top-card" key={index}>
              <div className="card-head">{card.title}</div>
              <div
                className="show-card-data"
                dangerouslySetInnerHTML={{ __html: card.value }}
              />
            </div>
          ))}
        </div> */}

        <div className="homepage-val-container">
          <div className="homepage-section">
            <div className="homepage-content-section">
              <div className="homepage-logo-container">
                <img src={logoIcon} />
              </div>
              <div className="homepage-value-section">
                <div className="card-head">AMC Price</div>
                <div className="card-value">${formatNumber(cardValue.amcPrice || 0)}</div>
              </div>
            </div>
            <Divider flexItem />
            <div className="homepage-content-section">
              <PiGlobe style={{height:"30px", width:"30px"}} />
              <div className="homepage-value-section">
                <div className="card-head">AMC Market Cap</div>
                <div className="card-value">${formatNumber(cardValue.amcMarketCap || 0)}</div>
              </div>
            </div>
          </div>

          <Divider orientation="vertical" flexItem />

          <div className="homepage-section">
            <div className="homepage-content-section">
              <img src={txnIcon} style={{ height:"20px" }}/>
              <div className="homepage-center-data">
                <div className="homepage-value-section">
                  <div className="card-head" style={{paddingTop:"0"}}>Transactions</div>
                  <div className="card-value">{cardValue?.totalTransactions || 0}</div>
                </div>
                <div className="homepage-value-section">
                  <div className="card-head" style={{paddingTop:"0"}}>Total Supply</div>
                  <div className="card-value" style={{textAlign:"right"}}>${formatNumber(cardValue?.supplies?.totalSupply || 0)}</div>
                </div>
              </div>
            </div>
            <Divider flexItem />
            <div className="homepage-content-section">
              <img src={blockIcon} style={{ height:"20px" }}/>

              <div className="homepage-center-data">
                <div className="homepage-value-section">
                  <div className="card-head" style={{paddingTop:"0"}}>Latest Block</div>
                  <div className="card-value">{cardValue.latestBlockInDb || 0}</div>
                </div>
                <div className="homepage-value-section">
                  <div className="card-head" style={{paddingTop:"0"}}>Circulating Supply</div>
                  <div className="card-value" style={{textAlign:"right"}}>${formatNumber(Math.floor(cardValue?.supplies?.currentCirculation))}</div>
                </div>
              </div>
            </div>
          </div>

          <Divider orientation="vertical" flexItem />

          <div className="homepage-section">
            <ResponsiveContainer width="100%" height={150}>
              <LineChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 10 }}>
                {/* Remove the CartesianGrid or modify strokeDasharray */}
                <XAxis dataKey="name" />
                <YAxis />
                <RechartsTooltip />
                <Legend />
                {/* Add fill to the Line to color the area under the graph */}
                <Line 
                  type="monotone" 
                  dataKey="value" 
                  stroke="rgb(7, 132, 195)" 
                  strokeWidth={2} 
                  fill="rgb(7, 132, 195)" 
                  fillOpacity={0.3} // You can adjust the opacity of the fill to make it look softer
                />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>

      <div className="home-page-container">
        {/* Custom scrollbar design */}
        <style>
          {`
            .custom-scrollbar::-webkit-scrollbar {
              width: 5px;
            }
            .custom-scrollbar::-webkit-scrollbar-track {
              background-color: #f1f1f1;
            }
            .custom-scrollbar::-webkit-scrollbar-thumb {
              background-color: #0784c3;
              border-radius: 4px;
            }
            .custom-scrollbar::-webkit-scrollbar-thumb:hover {
              background-color: #888;
            }

            /* For horizontal scrollbar */
            .custom-scrollbar::-webkit-scrollbar:horizontal {
              height: 5px;
              background-color: #f1f1f1;
            }
            .custom-scrollbar::-webkit-scrollbar-thumb:horizontal {
              background-color: #888;
              border-radius: 4px;
            }
            .custom-scrollbar::-webkit-scrollbar-thumb:horizontal:hover {
              background-color: #0784c3;
            }
          `}
        </style>

        {/* Block table */}
        <Paper className="paper-style table-container">
          <div className="home-page-heading">
            <div>
              <span className="dashboard-table-heading">Latest Blocks</span>
            </div>
            {/* <Button
              variant="outlined"
              color="default"
              size="small"
              style={{
                backgroundColor: "#F8F9FA",
                borderRadius: 8,
                display: "flex",
                alignItems: "center",
                textTransform: "capitalize",
              }}
            >
              <i
                className="ri-dashboard-line"
                style={{
                  color: "#0784C3",
                  marginRight: "5px",
                }}
              ></i>
              Customize
            </Button> */}
          </div>

          <TableContainer
            style={{ height: "608px" }}
            className="custom-scrollbar"
          >
            <Table>
              <TableBody>
                {blockTableData.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={3} align="center">
                      No data found
                    </TableCell>
                  </TableRow>
                ) : (
                  blockTableData.map((row) => (
                    <TableRow key={row._id} hover>
                      <TableCell className="cell-style">
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <Button
                            variant="outlined"
                            size="small"
                            style={{
                              backgroundColor: "#F8F9FA",
                              borderRadius: 8,
                              minWidth: "28px",
                              marginRight: "16px",
                            }}
                          >
                            <img
                              src={qubeimg}
                              alt="Logo"
                              height={22}
                              width={22}
                            />
                          </Button>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            <Link
                              to={`/block_details/${row.blockNumber}`}
                              style={{
                                color: "#0784C3",
                                textDecoration: "none",
                              }}
                            >
                              {row.blockNumber}
                            </Link>
                            <span className="timing-style">
                              {formatTimes(row.timestamp)}
                            </span>
                          </div>
                        </div>
                      </TableCell>
                      <TableCell className="cell-style">
                        <Tooltip title="Transactions in this block" arrow>
                          <Link
                            to={`/txn_for_block/${row.blockNumber}`}
                            style={{
                              color: "#0784C3",
                              textDecoration: "none",
                            }}
                          >
                            {row.transactionCount} transactions
                          </Link>
                        </Tooltip>
                      </TableCell>
                      <TableCell
                        className="cell-style"
                        style={{ textAlign: "right" }}
                      >
                        <Tooltip title="Block Reward" arrow>
                          <Button
                            variant="outlined"
                            color="default"
                            size="small"
                            style={{
                              fontSize: "11px",
                              fontWeight: "400",
                              backgroundColor: "#F8F9FA",
                              borderRadius: 8,
                            }}
                          >
                            {row.reward + " AMC"}
                          </Button>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>

            <TablePagination
              rowsPerPageOptions={[10]}
              component="div"
              count={blockTableData.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              style={{ display: "none" }}
            />
          </TableContainer>

          <div className="view-all-blocks-cant">
            <Link to="/new_block_page" style={{ textDecoration: "none" }}>
              <span className="view-all-blocks">View All Blocks</span>
              <i
                className="pi pi-arrow-right"
                style={{ fontSize: "10px", color: "#FFFFFF" }}
              ></i>
            </Link>
          </div>
        </Paper>

        {/* Transaction table */}
        <Paper className="paper-style table-container">
          <div className="home-page-heading">
            <div>
              <span className="dashboard-table-heading">
                Latest Transactions
              </span>
            </div>
            {/* <Button
              variant="outlined"
              color="default"
              size="small"
              style={{
                backgroundColor: "#F8F9FA",
                borderRadius: 8,
                display: "flex",
                alignItems: "center",
                textTransform: "capitalize",
              }}
            >
              <i
                className="ri-dashboard-line"
                style={{
                  color: "#0784C3",
                  marginRight: "5px",
                }}
              ></i>
              Customize
            </Button> */}
          </div>

          <TableContainer
            className="custom-scrollbar"
            style={{ height: "608px" }}
          >
            <Table>
              <TableBody>
                {transactionTableData.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={3} align="center">
                      No data found
                    </TableCell>
                  </TableRow>
                ) : (
                  transactionTableData.map((row) => (
                    <TableRow key={row._id} hover>
                      <TableCell className="cell-style">
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <Button
                            variant="outlined"
                            size="small"
                            style={{
                              backgroundColor: "#F8F9FA",
                              borderRadius: 8,
                              minWidth: "28px",
                              marginRight: "16px",
                            }}
                          >
                            <img
                              src={document}
                              alt="Logo"
                              height={22}
                              width={22}
                            />
                          </Button>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                              <Tooltip title={row?.hash} arrow>
                                <Link
                                  to={`/transactions_detail/${row?.hash}`}
                                  style={{
                                    color: "#0784C3",
                                    textDecoration: "none",
                                  }}
                                >
                                  {row?.hash.length > 16
                                  ? `${row?.hash.substring(0, 8)}...${row?.hash.substring(row?.hash.length - 8)}`
                                  : row?.hash}
                                </Link>
                              </Tooltip>
                              <div
                                onClick={() => copyToClipboard(row?.hash)}
                                style={{ marginLeft: 10, color: "gray", cursor: "pointer" }}
                              >
                                <IoMdCopy style={{ fontSize: "1.2rem" }} />
                              </div>
                              <Toaster position="top-right"/>
                            </div>

                            <span className="timing-style">
                              {formatTimes(row?.blockTimestamp)}
                            </span>
                          </div>
                        </div>
                      </TableCell>
                      <TableCell className="cell-style">
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <div className="transaction-timing">
                            <span>From</span>
                            {row?.tokenData && row?.tokenData.from ? (
                              <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                <Tooltip title={row?.tokenData?.from} arrow>
                                  <Link
                                    to={`/address/${row?.tokenData?.from}`}
                                    style={{
                                      color: "#0784C3",
                                      textDecoration: "none",
                                    }}
                                  >
                                    {row?.tokenData?.from.length > 16
                                    ? `${row?.tokenData?.from.substring(0, 8)}...${row?.tokenData?.from.substring(row?.tokenData?.from.length - 8)}`
                                    : row?.tokenData?.from}
                                  </Link>
                                </Tooltip>
                                <div
                                  onClick={() => copyToClipboard(row?.tokenData?.from)}
                                  style={{ marginLeft: 10, color: "gray", cursor: "pointer" }}
                                >
                                  <IoMdCopy style={{ fontSize: "1.2rem" }} />
                                </div>
                                <Toaster position="top-right"/>
                              </div>
                            ) : (
                              <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                <Tooltip title={row?.from} arrow>
                                  <Link
                                    to={`/address/${row?.from}`}
                                    style={{
                                      color: "#0784C3",
                                      textDecoration: "none",
                                    }}
                                  >
                                    {row?.from.length > 16
                                    ? `${row?.from.substring(0, 8)}...${row?.from.substring(row?.from.length - 8)}`
                                    : row?.from}
                                  </Link>
                                </Tooltip>
                                <div
                                  onClick={() => copyToClipboard(row?.from)}
                                  style={{ marginLeft: 10, color: "gray", cursor: "pointer" }}
                                >
                                  <IoMdCopy style={{ fontSize: "1.2rem" }} />
                                </div>
                                <Toaster position="top-right"/>
                              </div>
                            )}
                          </div>
                          <div className="transaction-timing">
                            <span>To</span>
                            {row?.tokenData && row?.tokenData.to ? (
                              <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                <Tooltip title={row?.tokenData?.to} arrow>
                                  <Link
                                    to={`/address/${row?.tokenData?.to}`}
                                    style={{
                                      color: "#0784C3",
                                      textDecoration: "none",
                                    }}
                                  >
                                    {row?.tokenData?.to.length > 16
                                    ? `${row?.tokenData?.to.substring(0, 8)}...${row?.tokenData?.to.substring(row?.tokenData?.to.length - 8)}`
                                    : row?.tokenData?.to}
                                  </Link>
                                </Tooltip>
                                <div
                                  onClick={() => copyToClipboard(row?.tokenData?.to)}
                                  style={{ marginLeft: 10, color: "gray", cursor: "pointer" }}
                                >
                                  <IoMdCopy style={{ fontSize: "1.2rem" }} />
                                </div>
                                <Toaster position="top-right"/>
                              </div>
                            ) : (
                              <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                <Tooltip title={row?.to} arrow>
                                  <Link
                                    to={`/address/${row?.to}`}
                                    style={{
                                      color: "#0784C3",
                                      textDecoration: "none",
                                    }}
                                  >
                                    {row?.to.length > 16
                                    ? `${row?.to.substring(0, 8)}...${row?.to.substring(row?.to.length - 8)}`
                                    : row?.to}
                                  </Link>
                                </Tooltip>
                                <div
                                  onClick={() => copyToClipboard(row?.to)}
                                  style={{ marginLeft: 10, color: "gray", cursor: "pointer" }}
                                >
                                  <IoMdCopy style={{ fontSize: "1.2rem" }} />
                                </div>
                                <Toaster position="top-right"/>
                              </div>
                            )}
                          </div>
                        </div>
                      </TableCell>
                      <TableCell
                        className="cell-style"
                        style={{ textAlign: "right" }}
                      >
                        {row?.tokenData && row?.tokenData?.value ? (
                          <Tooltip title="Amount" arrow>
                            <Button
                              variant="outlined"
                              color="default"
                              size="small"
                              style={{
                                fontSize: "11px",
                                fontWeight: "400",
                                backgroundColor: "#F8F9FA",
                                borderRadius: 8,
                              }}
                            >
                              {row?.tokenData?.value}&nbsp;{row?.tokenData?.token}
                            </Button>
                          </Tooltip>
                        ) : (
                          <Tooltip title="Amount" arrow>
                            <Button
                              variant="outlined"
                              color="default"
                              size="small"
                              style={{
                                fontSize: "11px",
                                fontWeight: "400",
                                backgroundColor: "#F8F9FA",
                                borderRadius: 8,
                              }}
                            >
                              {row?.value + " AMC"}
                            </Button>
                          </Tooltip>
                        )}
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>

            <TablePagination
              rowsPerPageOptions={[10]}
              component="div"
              count={transactionTableData.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              style={{ display: "none" }}
            />
          </TableContainer>

          <div className="view-all-blocks-cant">
            <Link to="/new_transactions" style={{ textDecoration: "none" }}>
              <span className="view-all-blocks">View All Transaction</span>
              <i
                className="pi pi-arrow-right"
                style={{ fontSize: "10px", color: "#FFFFFF" }}
              ></i>
            </Link>
          </div>
        </Paper>
      </div>

      <Footer />
    </>
  );
};

export default HomePage;
